import { render, staticRenderFns } from "./EnterpriseDetailsDuplicatas.vue?vue&type=template&id=774af7e0"
import script from "./EnterpriseDetailsDuplicatas.vue?vue&type=script&lang=js"
export * from "./EnterpriseDetailsDuplicatas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports